import type { Emitter } from 'mitt';
import type { IPopupEventBusEvents } from '@/types';

export function usePopupEventBus(): Emitter<IPopupEventBusEvents> {
  const nuxtApp = useNuxtApp();

  return nuxtApp.$popupEventBus;
}
